import { Link } from "react-router-dom";
import { dynamicImage } from "../../../Service";
import { FeatherIcons, Image } from "../../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { setToggleSidebar } from "../../../ReduxToolkit/Reducer/LayoutSlice";

const HeaderLogo = () => {
  const dispatch = useAppDispatch();
  const {toggleSidebar} = useAppSelector((state)=>state.layout)
  return (
    <div className="header-logo-wrapper col-auto p-0">
      <div className="logo-wrapper">
        <Link to={`/dashboard`}>
          <Image
            className="img-fluid"
            src={dynamicImage("logo-htsols.png")}
            alt="HtSol"
            style={{ height: "32px", width: "auto" }}
          />
        </Link>
      </div>
      <div className="toggle-sidebar">
        <FeatherIcons className="status_toggle middle sidebar-toggle" iconName="AlignCenter"  onClick={()=>dispatch(setToggleSidebar(!toggleSidebar))} />
      </div>
    </div>
  );
};

export default HeaderLogo;
